import { useState, useEffect } from 'react'

interface CountdownTime {
  days: number
  hours: number
  minutes: number
  seconds: number
  isExpired: boolean
}

function getNextFridayMidnight(): Date {
  const now = new Date()
  const dayOfWeek = now.getDay() // 0 = Sunday, 5 = Friday
  let daysUntilFriday = 5 - dayOfWeek

  if (daysUntilFriday < 0) {
    daysUntilFriday += 7
  }

  if (daysUntilFriday === 0) {
    const fridayMidnight = new Date(now)
    fridayMidnight.setHours(0, 0, 0, 0)
    if (now >= fridayMidnight) {
      daysUntilFriday = 7
    }
  }

  const target = new Date(now)
  target.setDate(now.getDate() + daysUntilFriday)
  target.setHours(0, 0, 0, 0)
  return target
}

export function useDeadlineCountdown(): CountdownTime {
  const [timeLeft, setTimeLeft] = useState<CountdownTime>({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    isExpired: false,
  })

  useEffect(() => {
    const target = getNextFridayMidnight()

    const update = () => {
      const now = new Date()
      const diff = target.getTime() - now.getTime()

      if (diff <= 0) {
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
          isExpired: true,
        })
        return
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24))
      const hours = Math.floor(
        (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      )
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((diff % (1000 * 60)) / 1000)

      setTimeLeft({ days, hours, minutes, seconds, isExpired: false })
    }

    update()
    const interval = setInterval(update, 1000)
    return () => clearInterval(interval)
  }, [])

  return timeLeft
}
